import { useRouter } from 'next/router';

import { publicEnv } from '~/features/environment/public';

import { singleQueryParamValueSchema } from '../models/promotions';
import { getSummer2026SaleVariant, resolveSummer2026SaleVariant } from '../utils/get-summer-2026-sale-variant';

import { usePromotion } from './use-promotion';

/**
 * Temporary preview override via `?force_promo=<promotionId>` (e.g. `SUMMER26US`, `SUMMER26G1`, `SUMMER26G2`).
 * Disabled in production; remove once CONENG-2451 Sanity promos are live.
 */
export function useSummer2026SaleVariant() {
  const { query } = useRouter();
  const { data: promotionData, isFetched: promotionFetched } = usePromotion();

  const forcedPromotionId =
    publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME !== 'production'
      ? singleQueryParamValueSchema.parse(query.force_promo)
      : undefined;

  const summer2026Variant = resolveSummer2026SaleVariant(forcedPromotionId, promotionData?.promotionId);
  const isSummer2026GateReady = getSummer2026SaleVariant(forcedPromotionId) != null || promotionFetched;

  return {
    isSummer2026GateReady,
    promoCode: promotionData?.promoCode,
    promotionId: promotionData?.promotionId,
    summer2026Variant,
  };
}
